<script>
import {
  View,
  Star,
  ChatDotRound,
  Document,
  Wallet,
  CircleClose,
  Share,
  List,
  Check,
  Edit,
  ArrowRight,
  Ticket,
  Coin,
  Setting
} from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'
import { goToLogin } from '@/utils/loginFlow'
import { isCompactViewport } from '@/utils/browser'
import { resolveProfilePhotoUrl } from '@/utils/photoUpload'

export default {
  name: 'MyPage',
  components: {
    View,
    Star,
    ChatDotRound,
    Document,
    Wallet,
    CircleClose,
    Share,
    List,
    Check,
    Edit,
    ArrowRight,
    Ticket,
    Coin,
    Setting
  },
  data() {
    return {
      compact: isCompactViewport(),
      stats: {
        visitedCount: 0,
        visitedmeCount: 0,
        likedCount: 0,
        likedmeCount: 0,
        mutuallikedCount: 0,
        commentCount: 0,
        commentmeCount: 0,
        listenCount: 0,
        momentsCount: 0,
        momentslikeCount: 0,
        momentsthumsupCount: 0,
        myTestsCount: 0,
        myCertsCount: 0,
        avatar: '',
        visiteCount: 0,
        testCount: 0,
        certificationCount: 0,
        blacklistCount: 0,
        blogCount: 0
      },
      vipInfo: {
        level: 0,
        expireAt: '',
        isVerified: 0
      },
      balance: 0,
      sections: [
        { id: 2, name: '访客记录', icon: 'View', count: 0 },
        { id: 3, name: '心理测试', icon: 'List', count: 0 },
        { id: 4, name: '实名认证', icon: 'Check', count: 0 },
        { id: 7, name: '账号安全', icon: 'Setting', path: '/user/password', desc: '改登录名与密码' },
        { id: 5, name: '黑名单', icon: 'CircleClose', count: 0 },
        { id: 6, name: '我的文章', icon: 'Edit', count: 0 }
      ],
      inviteReferralSections: [
        { id: 10, name: '绑定礼券', icon: 'Ticket', path: '/referral/bind-coupon', desc: '注册时可填或登录后随时绑定' },
        { id: 8, name: '我的礼券', icon: 'Ticket', path: '/referral/coupons', desc: '创建与分享礼券' },
        { id: 9, name: '推荐收益', icon: 'Coin', path: '/referral/earnings', desc: '查看推荐与分润' },
        { id: 11, name: '申请合伙人', icon: 'Share', path: '/referral/partner-apply', desc: '实名申请臻享资格' }
      ],
      creatorSections: [
        { id: 24, name: '实名认证', icon: 'Check', path: '/real-name-verification', desc: '上传身份证，提现与合伙人必选' },
        { id: 22, name: '提现申请', icon: 'Wallet', path: '/withdraw/apply', desc: '余额提现至银行卡' },
        { id: 20, name: '我的创作', icon: 'Edit', path: '/creator/works', desc: '课程与测评' },
        { id: 21, name: '创作者收入', icon: 'Coin', path: '/creator/income', desc: '内容销售分账' },
        { id: 23, name: '站内信', icon: 'ChatDotRound', path: '/user/messages', desc: '分润、申诉与礼遇通知' }
      ],
      socialStats: [
        { key: 'visitedCount', label: '我访问', icon: 'View', path: '/visite?tab=visited' },
        { key: 'visitedmeCount', label: '访问我', icon: 'View', path: '/visite?tab=visitedme' },
        { key: 'likedCount', label: '我喜欢', icon: 'Star', path: '/like?tab=liked' },
        { key: 'likedmeCount', label: '喜欢我', icon: 'Star', path: '/like?tab=likedme' },
        { key: 'mutuallikedCount', label: '互相喜欢', icon: 'Star', path: '/like?tab=mutualliked' },
        { key: 'commentCount', label: '我评论', icon: 'ChatDotRound', path: '/moment' },
        { key: 'commentmeCount', label: '评论我', icon: 'ChatDotRound', path: '/moment' }
      ],
      momentStats: [
        { key: 'momentsCount', label: '动态总数', icon: 'Document' },
        { key: 'momentslikeCount', label: '获赞', icon: 'Star' },
        { key: 'momentsthumsupCount', label: '点赞', icon: 'Star' }
      ]
    }
  },
  mounted() {
    this.onResize = () => {
      this.compact = isCompactViewport()
    }
    window.addEventListener('resize', this.onResize)
  },
  beforeUnmount() {
    if (this.onResize) {
      window.removeEventListener('resize', this.onResize)
    }
  },
  created() {
    if (this.$root.isLoggedIn) {
      this.fetchUserStats()
      this.fetchUserProfile()
      this.fetchUserBalance()
    }
  },
  methods: {
    getUserName() {
      const userInfo = localStorage.getItem('user_info')
      if (userInfo) {
        const user = JSON.parse(userInfo)
        return user.nickname || user.username || '我的主页'
      }
      return '我的主页'
    },

    async fetchUserStats() {
      try {
        const token = localStorage.getItem('jwt_token')
        const response = await fetch('/api/v1/user/stats', {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })

        const data = await response.json()
        if (data.code === 200 && data.data) {
          this.stats = {
            visitedCount: data.data.visitedCount || 0,
            visitedmeCount: data.data.visitedmeCount || 0,
            likedCount: data.data.likedCount || 0,
            likedmeCount: data.data.likedmeCount || 0,
            mutuallikedCount: data.data.mutuallikedCount || 0,
            commentCount: data.data.commentCount || 0,
            commentmeCount: data.data.commentmeCount || 0,
            listenCount: data.data.listenCount || 0,
            momentsCount: data.data.momentsCount || 0,
            momentslikeCount: data.data.momentslikeCount || 0,
            momentsthumsupCount: data.data.momentsthumsupCount || 0,
            myTestsCount: data.data.myTestsCount || 0,
            myCertsCount: data.data.myCertsCount || 0,
            avatar: resolveProfilePhotoUrl(data.data.avatar, data.data.photo) || '',
            visiteCount: data.data.visiteCount || 0,
            testCount: data.data.testCount || 0,
            certificationCount: data.data.certificationCount || 0,
            blacklistCount: data.data.blacklistCount || 0,
            blogCount: data.data.blogCount || 0
          }

          this.sections[0].count = this.stats.visitedmeCount
          this.sections[1].count = this.stats.myCertsCount
          this.sections[2].count = this.stats.certificationCount
          // sections[3] = 账号安全（无 count）
          this.sections[4].count = this.stats.blacklistCount
          this.sections[5].count = this.stats.blogCount
          this.fetchExtraSectionCounts()
        } else if (data.code === 401) {
          ElMessage.error(data.message)
          goToLogin(this.$router, '/my')
        } else {
          ElMessage.error(data.message)
        }
      } catch (error) {
        console.error('Failed to fetch user stats:', error)
      }
    },

    async fetchUserProfile() {
      try {
        const token = localStorage.getItem('jwt_token')
        const uuid = localStorage.getItem('uuid')
        const response = await fetch('/api/v1/user/myprofile/get', {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ uuid })
        })

        const data = await response.json()
        if (data.code === 200 && data.data) {
          this.vipInfo = {
            level: data.data.vip_level || 0,
            expireAt: data.data.vip_expire_at || '',
            isVerified: data.data.isVerified || 0
          }
        }
      } catch (error) {
        console.error('Failed to fetch user profile:', error)
      }
    },

    async fetchUserBalance() {
      try {
        const token = localStorage.getItem('jwt_token')
        const response = await fetch('/api/v1/user/balance', {
          method: 'GET',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })

        const data = await response.json()
        if (data.code === 200 && data.data && data.data.length > 0) {
          this.balance = (data.data[0].balance / 100).toFixed(2)
        }
      } catch (error) {
        console.error('Failed to fetch user balance:', error)
      }
    },

    async fetchExtraSectionCounts() {
      const token = localStorage.getItem('jwt_token')
      if (!token) return
      const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
      try {
        const [blackRes, blogRes] = await Promise.all([
          fetch('/api/v1/user/blacklist', {
            method: 'POST',
            headers,
            body: JSON.stringify({ page: 1, pageSize: 1 })
          }),
          fetch('/api/v1/blog/list/my', {
            method: 'POST',
            headers,
            body: JSON.stringify({ page: 1, pageSize: 1 })
          })
        ])
        const blackData = await blackRes.json()
        if (blackData.code === 200) {
          this.stats.blacklistCount = blackData.data?.total || 0
          this.sections[4].count = this.stats.blacklistCount
        }
        const blogData = await blogRes.json()
        if (blogData.code === 200) {
          this.stats.blogCount = blogData.data?.total || 0
          this.sections[5].count = this.stats.blogCount
        }
      } catch (e) {
        console.error('Failed to fetch extra section counts:', e)
      }
    },

    goSocialStat(item) {
      if (item?.path) {
        this.$router.push(item.path)
      }
    },

    navigateToSection(section) {
      if (section.path) {
        this.$router.push(section.path)
        return
      }
      switch (section.id) {
        case 2:
          this.$router.push('/visite?tab=visitedme')
          break
        case 3:
          this.$router.push('/exam/my-results')
          break
        case 4:
          this.$router.push('/real-name-verification')
          break
        case 5:
          this.$router.push('/blacklist')
          break
        case 6:
          this.$router.push('/blogs/list/my')
          break
      }
    },

    navigateToRecharge() {
      this.$router.push('/recharge')
    },

    navigateToRechargeList() {
      this.$router.push('/recharge/list')
    },

    navigateToList() {
      this.$router.push('/transactions')
    },

    navigateToRealNameVerification() {
      this.$router.push('/real-name-verification')
    },

    navigateToWithdraw() {
      this.$router.push('/withdraw/apply')
    }
  }
}
</script>

<template>
  <div class="my-page" :class="{ 'my-page--compact': compact }">
    <div class="profile-header">
      <div class="profile-basic">
        <div class="avatar-container">
          <img
            :src="stats.avatar || 'https://picsum.photos/100/100?random=1'"
            alt="头像"
            class="avatar"
          >
        </div>
        <div class="user-info">
          <h2>{{ getUserName() }}</h2>
          <div class="vip-info">
            <el-tag type="warning" v-if="vipInfo.level > 0">VIP {{ vipInfo.level }}</el-tag>
            <el-tag v-else>普通用户</el-tag>
            <span class="vip-hint">暂不支持自助购买</span>
            <span v-if="vipInfo.expireAt && !compact" class="expire-time">
              到期: {{ new Date(vipInfo.expireAt).toLocaleDateString() }}
            </span>
            <el-tag v-if="vipInfo.isVerified != 0" type="success" size="small">已实名</el-tag>
          </div>
          <div class="balance-info balance-info--action" @click="navigateToWithdraw">
            <el-icon><Wallet /></el-icon>
            <span>余额 ¥{{ balance }}</span>
            <span class="balance-info__link">去提现</span>
          </div>
        </div>
      </div>

      <div class="action-buttons">
        <el-button type="primary" size="small" @click="navigateToRecharge">充值</el-button>
        <el-button type="warning" size="small" @click="navigateToWithdraw">提现</el-button>
        <el-button type="info" size="small" plain @click="navigateToRechargeList">充值记录</el-button>
        <el-button type="success" size="small" plain @click="navigateToList">账单明细</el-button>
        <el-button
          v-if="vipInfo.isVerified == 0"
          type="warning"
          size="small"
          plain
          @click="navigateToRealNameVerification"
        >
          实名认证
        </el-button>
        <el-button
          v-else
          type="success"
          size="small"
          plain
          disabled
        >
          已实名
        </el-button>
      </div>

      <div class="stats-grid stats-grid--social">
        <div
          v-for="item in socialStats"
          :key="item.key"
          class="stat-item stat-item--clickable"
          @click="goSocialStat(item)"
        >
          <el-icon><component :is="item.icon" /></el-icon>
          <span class="count">{{ stats[item.key] }}</span>
          <span class="label">{{ item.label }}</span>
        </div>
      </div>
    </div>

    <div class="sections-panel">
      <h3 class="panel-title">功能入口</h3>
      <div v-if="compact" class="sections-list">
        <button
          v-for="section in sections"
          :key="section.id"
          type="button"
          class="sections-list__item"
          @click="navigateToSection(section)"
        >
          <el-icon class="sections-list__icon">
            <component :is="section.icon" />
          </el-icon>
          <span class="sections-list__name">{{ section.name }}</span>
          <span v-if="section.count > 0" class="sections-list__count">{{ section.count }}</span>
          <el-icon class="sections-list__arrow"><ArrowRight /></el-icon>
        </button>
      </div>
      <div v-else class="sections-grid">
        <el-card
          v-for="section in sections"
          :key="section.id"
          class="section-card"
          shadow="hover"
          @click="navigateToSection(section)"
        >
          <div class="section-content">
            <el-icon class="section-icon">
              <component :is="section.icon" />
            </el-icon>
            <div class="section-info">
              <h3>{{ section.name }}</h3>
              <span class="count">{{ section.count }}</span>
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <div class="sections-panel invite-referral-panel">
      <h3 class="panel-title">礼券与推荐</h3>
      <p class="invite-referral-hint">创建并分享礼券：新用户通过<strong>注册链接</strong>注册时自动绑券；老用户通过<strong>绑定链接</strong>补绑礼遇。</p>
      <div v-if="compact" class="sections-list">
        <button
          v-for="section in inviteReferralSections"
          :key="section.id"
          type="button"
          class="sections-list__item"
          @click="navigateToSection(section)"
        >
          <el-icon class="sections-list__icon">
            <component :is="section.icon" />
          </el-icon>
          <span class="sections-list__name">{{ section.name }}</span>
          <span class="sections-list__desc">{{ section.desc }}</span>
          <el-icon class="sections-list__arrow"><ArrowRight /></el-icon>
        </button>
      </div>
      <div v-else class="sections-grid">
        <el-card
          v-for="section in inviteReferralSections"
          :key="section.id"
          class="section-card"
          shadow="hover"
          @click="navigateToSection(section)"
        >
          <div class="section-content">
            <el-icon class="section-icon">
              <component :is="section.icon" />
            </el-icon>
            <div class="section-info">
              <h3>{{ section.name }}</h3>
              <span class="section-desc">{{ section.desc }}</span>
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <div class="sections-panel invite-referral-panel">
      <h3 class="panel-title">创作与提现</h3>
      <div v-if="compact" class="sections-list">
        <button
          v-for="section in creatorSections"
          :key="section.id"
          type="button"
          class="sections-list__item"
          @click="navigateToSection(section)"
        >
          <el-icon class="sections-list__icon">
            <component :is="section.icon" />
          </el-icon>
          <span class="sections-list__name">{{ section.name }}</span>
          <span class="sections-list__desc">{{ section.desc }}</span>
          <el-icon class="sections-list__arrow"><ArrowRight /></el-icon>
        </button>
      </div>
      <div v-else class="sections-grid">
        <el-card
          v-for="section in creatorSections"
          :key="section.id"
          class="section-card"
          shadow="hover"
          @click="navigateToSection(section)"
        >
          <div class="section-content">
            <el-icon class="section-icon">
              <component :is="section.icon" />
            </el-icon>
            <div class="section-info">
              <h3>{{ section.name }}</h3>
              <span class="section-desc">{{ section.desc }}</span>
            </div>
          </div>
        </el-card>
      </div>
    </div>

    <div class="moments-stats">
      <h3 class="panel-title">动态统计</h3>
      <div class="stats-grid stats-grid--moments">
        <div v-for="item in momentStats" :key="item.key" class="stat-item">
          <el-icon><component :is="item.icon" /></el-icon>
          <span class="count">{{ stats[item.key] }}</span>
          <span class="label">{{ item.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.my-page {
  max-width: 1800px;
  margin: 0 auto;
  padding: 20px;
  box-sizing: border-box;
}

.my-page--compact {
  max-width: none;
  padding: 0;
  background: #f7f8fa;
  min-height: calc(100vh - 52px);
}

.profile-header,
.moments-stats,
.sections-panel {
  background-color: #fff;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
}

.my-page--compact .profile-header,
.my-page--compact .moments-stats,
.my-page--compact .sections-panel {
  padding: 12px;
  margin: 0 0 8px;
  border-radius: 0;
  box-shadow: none;
  border: none;
  border-bottom: 1px solid #ebeef5;
}

.panel-title {
  margin: 0 0 14px;
  font-size: 15px;
  font-weight: 600;
  color: var(--el-text-color-primary);
}

.profile-basic {
  display: flex;
  align-items: flex-start;
  margin-bottom: 16px;
}

.my-page--compact .profile-basic {
  align-items: center;
  gap: 14px;
}

.avatar-container {
  flex-shrink: 0;
  margin-right: 20px;
}

.my-page--compact .avatar-container {
  margin-right: 0;
}

.avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;
}

.my-page--compact .avatar {
  width: 64px;
  height: 64px;
}

.user-info {
  flex: 1;
  min-width: 0;
}

.user-info h2 {
  margin: 0 0 10px;
  color: var(--el-text-color-primary);
  font-size: 20px;
}

.my-page--compact .user-info h2 {
  font-size: 18px;
  margin-bottom: 8px;
}

.vip-info {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.expire-time {
  font-size: 13px;
  color: var(--el-text-color-secondary);
}

.vip-hint {
  font-size: 12px;
  color: var(--el-text-color-secondary);
}

.balance-info {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  font-weight: 600;
  color: var(--el-text-color-primary);
}

.my-page--compact .balance-info {
  font-size: 15px;
}

.balance-info .el-icon {
  color: var(--el-color-warning);
}

.balance-info--action {
  cursor: pointer;
  padding: 4px 8px;
  margin: -4px -8px;
  border-radius: 8px;
  transition: background 0.15s;
}

.balance-info--action:hover {
  background: var(--el-fill-color-light);
}

.balance-info__link {
  margin-left: 6px;
  font-size: 13px;
  font-weight: 500;
  color: var(--el-color-primary);
}

.action-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--el-border-color-lighter);
}

.my-page--compact .action-buttons {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.my-page--compact .action-buttons .el-button {
  margin: 0;
  width: 100%;
}

.my-page--compact .action-buttons .el-button:last-child:nth-child(odd) {
  grid-column: span 2;
}

.stats-grid {
  display: grid;
  gap: 12px;
}

.stats-grid--social {
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
}

.stats-grid--moments {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.my-page--compact .stats-grid--social {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.my-page--compact .stats-grid--moments {
  gap: 8px;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 8px 4px;
  border-radius: 8px;
  background: #fafbfc;
}

.stat-item--clickable {
  cursor: pointer;
}

.stat-item--clickable:hover {
  background: #f0f5ff;
}

.my-page--compact .stat-item {
  padding: 10px 4px;
}

.stat-item .el-icon {
  font-size: 22px;
  color: var(--el-color-primary);
  margin-bottom: 4px;
}

.my-page--compact .stat-item .el-icon {
  font-size: 18px;
}

.count {
  font-size: 17px;
  font-weight: 700;
  color: var(--el-text-color-primary);
  line-height: 1.2;
}

.my-page--compact .count {
  font-size: 15px;
}

.label {
  font-size: 11px;
  color: var(--el-text-color-secondary);
  line-height: 1.3;
  margin-top: 2px;
}

.sections-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 16px;
}

.section-card {
  cursor: pointer;
}

.section-card :deep(.el-card__body) {
  padding: 16px;
}

.section-content {
  display: flex;
  align-items: center;
}

.section-icon {
  font-size: 24px;
  color: var(--el-color-primary);
  margin-right: 15px;
}

.section-info h3 {
  margin: 0 0 5px;
  font-size: 16px;
  color: var(--el-text-color-primary);
}

.section-info .count {
  font-size: 14px;
  font-weight: normal;
  color: var(--el-text-color-secondary);
}

.section-desc {
  font-size: 13px;
  color: var(--el-text-color-secondary);
}

.invite-referral-panel {
  margin-top: 8px;
}

.invite-referral-hint {
  margin: 0 0 16px;
  font-size: 14px;
  color: #606266;
  line-height: 1.6;
}

.sections-list__desc {
  font-size: 12px;
  color: #909399;
  margin-right: 8px;
}

.sections-list {
  display: flex;
  flex-direction: column;
}

.sections-list__item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 14px 4px;
  border: none;
  border-bottom: 1px solid #f0f2f5;
  background: transparent;
  cursor: pointer;
  text-align: left;
  gap: 10px;
}

.sections-list__item:last-child {
  border-bottom: none;
}

.sections-list__item:active {
  background: #f5f7fa;
}

.sections-list__icon {
  font-size: 20px;
  color: #42b983;
}

.sections-list__name {
  flex: 1;
  font-size: 15px;
  color: #303133;
}

.sections-list__count {
  font-size: 13px;
  color: #909399;
  min-width: 1.5em;
  text-align: right;
}

.sections-list__arrow {
  font-size: 14px;
  color: #c0c4cc;
}

.moments-stats h3.panel-title {
  margin-bottom: 12px;
}

@media screen and (max-width: 380px) {
  .my-page--compact .stats-grid--social {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
